<template>
  <PageWrapper
    v-if="canView"
    :active-section="SECTION_PUBLICATIONS"
    :active-page="PAGE_PUBLICATION_USERS"
    title="My Users"
    sub-title="Manage your users"
    :breadcrumbs="breadcrumbs"
    page-name="My Users"
    align="center"
    width="full"
    action-button-text="Add User"
    :action-button-disabled="!canInviteUsers"
    @click:action="openAddUserModal"
  >
    <SmartFeed
      :pinia-store="useMyPublicationUsersFeedStore"
      default-entity-layout="tableRow"
      default-smart-feed-layout="table"
    >
      <template #empty-state>
        <iRow vertical-align="middle" class="empty-state">
          <iIcon icon="person" size="large" />
          <iText>No users yet.</iText>
        </iRow>
      </template>
    </SmartFeed>
  </PageWrapper>
  <iText v-else>
    You don't have access to view this page.
  </iText>
  <InvitePublicationUserModal
    v-if="showAddUserModal"
    :publication-id="publicationId"
    @close="showAddUserModal = false"
  />
</template>

<script>
import PageWrapper from "@/components/PageWrapper.vue";
import { mapState } from "pinia";
import { useCreatorPublicationStore } from "%/stores/creator-publication-store";
import {
  PAGE_PUBLICATION_USERS,
  SECTION_PUBLICATIONS,
} from "@/constants/nav-constants";
import SmartFeed from "SmartFeed/components/SmartFeed";
import { useMyPublicationUsersFeedStore } from "SmartFeed/stores/feed/my-publication-users-feed-store";
import InvitePublicationUserModal from "@/components/publication/InvitePublicationUserModal";
import { useCollaboratorStore } from "@/stores/collaborator-store";

export default {
  name: "PublicationUserManagement",
  components: {
    SmartFeed,
    PageWrapper,
    InvitePublicationUserModal,
  },
  data() {
    return {
      PAGE_PUBLICATION_USERS,
      SECTION_PUBLICATIONS,
      showAddUserModal: false,
    };
  },
  computed: {
    ...mapState(useCreatorPublicationStore, [
      "orgId",
      "publication",
      "publicationId",
    ]),
    ...mapState(useCollaboratorStore, [
      "canView",
      "canInviteUsers",
    ]),
    breadcrumbs() {
      return [
        { url: "/", label: "Home" },
        { url: `/publication/org/${this.orgId}`, label: "My Publications" },
        { url: `/publication/${this.publicationId}`, label: "Overview" },
      ];
    },
  },
  mounted() {
    if (!this.canView) {
      const baseUrl = window.location.origin;
      const redirectUrl = `${baseUrl}/publication/${this.publicationId}`;

      setTimeout(() => {
        window.location.href = redirectUrl;
      }, 2000);
    }
  },
  methods: {
    useMyPublicationUsersFeedStore,
    openAddUserModal() {
      this.showAddUserModal = true;
    },
  },
};
</script>

<style scoped lang="scss">

</style>
